/* eslint-disable default-case */
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

const Container = ({ children }) => (
  <div>
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "description": "Kuma Learn offers you a visual approach to learning Japanese. Learn Japanese with pictures. Download a free mini-eBook today.",
            "url": "https://www.kumalearn.com",
            "name": "Kuma Learn",
            "logo": "https://www.kumalearn.com/images/logo_lg.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "email": "hello@kumalearn.com",
              "contactType": "Contact"
            }
          }
        `}
      </script>
    </Helmet>
    <Helmet>
      <script>
        {`
            !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";
            analytics.load("phwED5FXq056RtbJDj1W5ABht5W1Ph5c");
            analytics.page();
            }}();
          `}
      </script>
    </Helmet>
    <div className="flex flex-col min-h-screen">
      <Header />
      <div style={{ flex: 1 }}>
        {children}
      </div>
      <div className="mt-36">
        <Footer />
      </div>
    </div>
  </div>
);

export default Container;
